const common = require("lib/labels/_common");

module.exports = {
  memberList: {
    title: {
      en: "Members",
      fr: "Membres"
    },
    edit: common.edit,
    remove: common.remove,
    profile: common.profile,
    login: {
      en: "Login",
      fr: "Identifiant"
    },
    password: common.password,
    validate: {
      en: "Validate",
      fr: "Accepter"
    },
    name: {
      en: "Name",
      fr: "Nom"
    },
    online: {
      en: "Online",
      fr: "En ligne"
    }
  },
  memberForm: {
    stepTitle: common.member,
    title: {
      edition: {
        en: "Member edition",
        fr: "Edition de membre"
      },
      creation: {
        en: "Member Creation",
        fr: "Création de membre"
      }
    },
    password: common.password,
    login: {
      en: "Login",
      fr: "Identifiant"
    },
    profile: common.profile
  },
  personalForm: {
    stepTitle: {
      en: "Personal",
      fr: "Données personnelles"
    },
    title: {
      en: "Personal",
      fr: "Données personnelles"
    },
    gender: {
      label: {
        en: "Gender",
        fr: "Genre"
      },
      female: {
        en: "Female",
        fr: "Femme"
      },
      male: {
        en: "Male",
        fr: "Homme"
      }
    },
    firstName: {
      en: "Firstname",
      fr: "Prénom"
    },
    lastName: {
      en: "Lastname",
      fr: "Nom"
    },
    birthDate: {
      label: {
        en: "Birth date",
        fr: "Date de naissance"
      },
      cancel: common.cancel,
      ok: {
        en: "OK",
        fr: "Valider"
      }
    }
  },
  contactForm: {
    stepTitle: {
      en: "Contact",
      fr: "Contact"
    },
    title: {
      en: "Contact",
      fr: "Contact"
    },
    email: {
      label: common.email,
      text: {
        en: "Set a member e-mail",
        fr: "Donnez un email au membre"
      }
    },
    phone: {
      en: "Phone",
      fr: "Téléphone"
    },
    mobile: {
      en: "Mobile",
      fr: "Mobile"
    }
  },
  validateForm: {
    stepTitle: {
      en: "User validation",
      fr: "Accepter l'utilisateur"
    },
    title: {
      en: "Member profile",
      fr: "Profil du membre"
    },
    profile: common.profile
  }
};
